module.exports = {
  presetUserTags: [
    { id: 'appInstalled', name: 'アプリインストール済み', isPreset: true },
  ],
};
